export default ({accept, change}:{accept: string, change: (file: File) =>}) ->
  accept ?= ""

  input := document.createElement 'input'
  input.type = "file"
  input.setAttribute "accept", accept

  input.onchange = ->
    if file := input.files?[0]
      change(file) if file
      input.value = ''

  return input
